import React from 'react'
import { Button } from 'react-native-elements'

import { View } from 'react-native'
import spacing from '../../styles/spacing'
import colors from '../../styles/colors'
export const PageButton = ({ option, active, onPress, disabled }) => {
  const foreColor = option.errors ? colors.redDark : colors.blueDarkest
  return (
    <View key={option.index} style={{ paddingTop: spacing.m0_5 }}>
      <Button
        title={`${option.name}${option.errors ? '*' : ''}`}
        buttonStyle={{
          borderRadius: 12,
          borderWidth: 1,
          borderColor: foreColor,
          backgroundColor: active ? foreColor : colors.white,
          maxWidth: 300
        }}
        disabled={disabled}
        titleStyle={{ color: active ? colors.white : foreColor }}
        type={active ? undefined : 'outline'}
        onPress={onPress}
      ></Button>
    </View>
  )
}
